export default {
  FOLDER: [],
  ID: ''
}
